export default {
	root: {}
};
